@if (showResetModal) {
  <reset-pwd-modal
    [currentUser]="userToUpdate"
    (onClose)="showResetModal = false"
  ></reset-pwd-modal>
}

<div>
  <app-search-bar
    [placeholder]="'Search'"
    [(filterParameter)]="userFilter"
    (searchEvent)="search()"
    (resetFilterEvent)="resetFilter()"
    >
  </app-search-bar>

  <div class="list-group">
    @for (user of userList | filter : userFilter : true; track user) {
      <div
        class="list-group-item-container"
        >
        <div class="list-group-item">
          <div class="row-picture" (click)="resetUserPwd(user)">
            @if (user.avatar) {
              <img
                [title]="user.availability === 'OFF' ? 'On leave' : 'At work'"
                [ngClass]="getStyle(user)"
                [src]="user.avatar"
                alt="avatar"
                />
            }
            @if (!user.avatar) {
              <div
                [title]="user.availability === 'OFF' ? 'On leave' : 'At work'"
                [ngClass]="getStyle(user)"
                >
                {{ user.userLogin | trigrammePipe }}
              </div>
            }
          </div>
          <div class="row-content">
            <span class="list-group-item-heading"
              >{{ user.userFirstName }} {{ user.userName }}
            </span>
            <div class="list-group-item-text">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12">
                    {{ user.userMailAddress
                    }}<i class="material-icons"
                    ><a href="mailto:{{ user.userMailAddress }}">&#xE0BE;</a></i
                    >
                  </div>
                  @if (user.userPhoneNumber) {
                    <div class="col-md-12">
                      {{ user.userPhoneNumber
                      }}<i class="material-icons">&#xE0CD;</i>
                    </div>
                  }
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (user.visible) {
        <div class="list-group-separator"></div>
      }
    </div>
  }
</div>
</div>
